import * as React from "react";
import {ConditionBuilder} from "./Core/ConditionBuilder";
import {DocumentManager} from "../../../Manager/PDFManager/DocumentManager";

export class ConditionTab extends React.Component<ConditionTabProps, ConditionTabState> {
	static defaultProps: Partial<ConditionTabProps> = {};

	constructor(props: ConditionTabProps) {
		super(props);
		this.state = {};
	}


	public render() {
		return (
			<div>
				<p>The pdf is not going to be attached to the emails if the condition bellow is met.</p>

				<ConditionBuilder Fields={this.props.DocumentManager.GetFields()} Styles={{marginTop:5}} Condition={this.props.DocumentManager.Options.SkipCondition}/>
			</div>
		)
	}
}



//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ConditionTabProps {
	DocumentManager:DocumentManager;
}

interface ConditionTabState {

}

//#endregion "My Region"